/** @format */

import { IncrementCounter } from "@ui-library/core/lib/molecules/IncrementCounter"
import {
	IncrementCounterProps,
	OnChangeFn,
} from "@ui-library/core/lib/molecules/IncrementCounter/src/types"
import { useRef, useEffect, useState, useCallback } from "react"

const IncrementCounterFixed = (props: IncrementCounterProps) => {
	const divRef = useRef<HTMLDivElement>(null);
	const valueRef = useRef<number|null>(null);

	const [inputFocusin, setInputFocusin] = useState(false)

	const {min,max,onChange  } = props;

	const manageOnChange = useCallback(() => {
		if (valueRef?.current === null) return;
		if (!onChange) return;

		const value = valueRef.current;

		if ((!min || min <= value) &&
				(!max || max >= value)) {
			return onChange(value)
		}
	}, [min, max, onChange]);

	const innerOnChange: OnChangeFn = value => {
		valueRef.current = value;

		if(!inputFocusin){
			manageOnChange();
		}
	}

	const newProps: IncrementCounterProps = {
		...props,
		onChange: innerOnChange,
	}

	const onFocusin = useCallback(
		() => {
			setInputFocusin(true);
	}, []);

	const onFocusOut = useCallback(
		() => {
			setInputFocusin(false);
			manageOnChange();
	}, [manageOnChange]);

	useEffect(()=> {
		if(divRef?.current){

			const input = divRef.current.getElementsByTagName("input")[0];

			input.addEventListener("focusin",onFocusin);
			input.addEventListener("focusout", onFocusOut);

			return () => {
				input.removeEventListener("focusin", onFocusin);
				input.removeEventListener("focusin", onFocusOut);
			}
		}
	}, [divRef, onFocusin, onFocusOut]);

	return <div style={{display:"inline-block"}} ref={divRef}>
					 <IncrementCounter {...newProps} />
				 </div>
}

export default IncrementCounterFixed
